var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsDateString, IsNumber, IsObject, IsUUID, ValidateNested, } from 'class-validator';
import { ActivityPointLevel } from '../../activity-point/const/activity-point-levels.const.js';
import { CallLiteDto } from '../../calls/dto/call.lite-dto.js';
export class ExerciseProgramStats {
    pendingCount;
    completedCount;
    pendingActivityPoints;
    aquiredActivityPoints;
}
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], ExerciseProgramStats.prototype, "pendingCount", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], ExerciseProgramStats.prototype, "completedCount", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], ExerciseProgramStats.prototype, "pendingActivityPoints", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], ExerciseProgramStats.prototype, "aquiredActivityPoints", void 0);
export class PreventionCourseStats {
    //currentModule: PreventionCourseModuleFullSizeDto;
    //currentModuleStats: PreventionCourseModuleStatsFullSizeDto;
    pendingActivityPoints;
    aquiredActivityPoints;
}
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], PreventionCourseStats.prototype, "pendingActivityPoints", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], PreventionCourseStats.prototype, "aquiredActivityPoints", void 0);
export class PatientStatusDto {
    id;
    createdAt;
    updatedAt;
    patientId;
    patient;
    totalActivityPoints;
    currentActivityPointLevel;
    hasCompletedDiagnosis;
    hasCompletedProfile;
    hasCompletedDiagnosisToday;
    hasCompletedOnboarding;
    exerciseProgramStats;
    preventionCourseStats;
    pendingVideoCalls;
    completedVideoCalls;
    get hasPendingItems() {
        return (this.exerciseProgramStats.pendingCount > 0 ||
            !this.hasCompletedOnboarding ||
            !this.hasCompletedProfile ||
            !this.hasCompletedDiagnosis ||
            this.pendingVideoCalls.length > 0);
    }
    get hasCompletedItemsToday() {
        return (this.exerciseProgramStats.completedCount > 0 ||
            this.hasCompletedDiagnosisToday ||
            this.completedVideoCalls.length > 0);
    }
    get patientOfficeId() {
        return this.patient.officeId;
    }
}
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], PatientStatusDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], PatientStatusDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], PatientStatusDto.prototype, "updatedAt", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], PatientStatusDto.prototype, "patientId", void 0);
__decorate([
    Exclude(),
    IsObject(),
    __metadata("design:type", Function)
], PatientStatusDto.prototype, "patient", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], PatientStatusDto.prototype, "totalActivityPoints", void 0);
__decorate([
    IsObject(),
    Type(() => ActivityPointLevel),
    Expose(),
    __metadata("design:type", ActivityPointLevel)
], PatientStatusDto.prototype, "currentActivityPointLevel", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], PatientStatusDto.prototype, "hasCompletedDiagnosis", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], PatientStatusDto.prototype, "hasCompletedProfile", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], PatientStatusDto.prototype, "hasCompletedDiagnosisToday", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], PatientStatusDto.prototype, "hasCompletedOnboarding", void 0);
__decorate([
    Expose(),
    IsObject(),
    Type(() => ExerciseProgramStats),
    __metadata("design:type", ExerciseProgramStats)
], PatientStatusDto.prototype, "exerciseProgramStats", void 0);
__decorate([
    IsObject(),
    Type(() => PreventionCourseStats),
    Expose(),
    __metadata("design:type", PreventionCourseStats)
], PatientStatusDto.prototype, "preventionCourseStats", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Expose(),
    Type(() => CallLiteDto),
    __metadata("design:type", Array)
], PatientStatusDto.prototype, "pendingVideoCalls", void 0);
__decorate([
    ValidateNested({ each: true }),
    Expose(),
    Type(() => CallLiteDto),
    __metadata("design:type", Array)
], PatientStatusDto.prototype, "completedVideoCalls", void 0);
//# sourceMappingURL=patient-status.dto.js.map